import { todayKey } from "@/lib/quiz";

const STORAGE_KEY = "wct.state.v1";

const defaultState = () => ({
  totalAnswered: 0,
  totalCorrect: 0,
  history: [], // [{ date: "YYYY-MM-DD", correct: number, total: number }]
  today: null, // { date, session: [...], index, correct }
  dataSourceUrl: "", // future Google Sheets URL
});

export function loadState() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultState();
    const parsed = JSON.parse(raw);
    return { ...defaultState(), ...parsed };
  } catch {
    return defaultState();
  }
}

export function saveState(state) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function resetIfNewDay(state) {
  const today = todayKey();
  if (state.today && state.today.date !== today) {
    // Archive previous day if it had any answers logged
    if (state.today.index > 0) {
      const exists = state.history.find((h) => h.date === state.today.date);
      if (!exists) {
        state.history = [
          ...state.history,
          {
            date: state.today.date,
            correct: state.today.correct,
            total: state.today.index,
          },
        ];
      }
    }
    state.today = null;
  }
  return state;
}

export function archiveTodayIfComplete(state) {
  if (!state.today) return state;
  const exists = state.history.find((h) => h.date === state.today.date);
  if (exists) return state;
  state.history = [
    ...state.history,
    {
      date: state.today.date,
      correct: state.today.correct,
      total: state.today.index,
    },
  ];
  return state;
}

export function clearAllProgress() {
  localStorage.removeItem(STORAGE_KEY);
}
